module.exports = __webpack_public_path__ + "static/TWDC-ca8b6e00d164bf2a3ac2e025bb68c638.png";